import { render, staticRenderFns } from "./DocumentConfidentiality.vue?vue&type=template&id=7a5fbb7c&"
import script from "./DocumentConfidentiality.vue?vue&type=script&lang=js&"
export * from "./DocumentConfidentiality.vue?vue&type=script&lang=js&"
import style0 from "./DocumentConfidentiality.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports